import { useState } from "react";

// force component update
export default function useForceUpdate(): () => void {
    const [, setValue] = useState(0); // integer state
    return () => setValue((value) => value + 1); // update the state to force render
}
